// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"336":"480dced2d026ca27","401":"7101965ca00538e7"}[chunkId] + ".js";
};